<template>
  <div class="brand-modal">
    <div class="header">
      <img class="close-icon" src="@/assets/close_b.png" @click="$emit('close')"/>
    </div>
    <div class="content pc">
      <div class="row upper">
        <div class="image brand-image">
          <img :src="generateImage(`${brand.name}_img.png`)" />
        </div>
        <p class="text description" v-html="brand.description">
        </p>
      </div>
      <div class="row lower">
        <div class="image brand-logo">
          <img :src="generateImage(`${brand.name}_logo.png`)" />
        </div>
        <div class="text profile">
          <span class="designer">{{ brand.designerName }}</span> {{ brand.title }}
          <p class="born">{{ brand.born }}</p>
          <p class="profile" v-html="brand.profile"></p>
        </div>
      </div>
      <a class="link" target="_blank" :href="brand.url">{{ brand.url }}</a>
    </div>
    <div class="content sp">
          <div class="brand-image">
            <img :src="generateImage(`${brand.name}_img.png`)" />
          </div>
          <div class="brand-logo">
            <img :src="generateImage(`${brand.name}_logo.png`)" />
          </div>
          <p class="text description" v-html="brand.description">
          </p>
          <div class="text profile">
            <span class="designer">{{ brand.designerName }}</span> {{ brand.title }}
            <p class="born">{{ brand.born }}</p>
            <p class="profile" v-html="brand.profile"></p>
          </div>
          <a class="link" target="_blank" :href="brand.url">{{ brand.url }}</a>
    </div>
    <div class="footer">
      <div class="arrow">
        <img class="left" src="@/assets/arrow_left.png" @click="back"/>
        <img class="right" src="@/assets/arrow_right.png" @click="next"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandModal',
  props: {
    brand: {
      type: Object,
      required: false,
      default: () => ({
        name: '',
        url: '',
        description: '',
        designerName: '',
        title: '',
        born: '',
        profile: ''
      })
    },
    currentIndex: {
      type: Number,
      required: true
    },
    maxIndex: {
      type: Number,
      required: true
    }
  },
  methods: {
    generateImage (file) {
      return require(`@/assets/${file}`)
    },
    next () {
      if (this.currentIndex === this.maxIndex) {
        this.$emit('change', 0)
      } else {
        this.$emit('change', this.currentIndex + 1)
      }
    },
    back () {
      if (this.currentIndex === 0) {
        this.$emit('change', this.maxIndex)
      } else {
        this.$emit('change', this.currentIndex - 1)
      }
    }
  }
}
</script>

<style scoped>
.brand-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-flow: column;
  background-color: #F4F4F0;
  box-sizing: border-box;
}
.header {
  text-align: right;
  padding-bottom: 25px;
}
.content {
  flex: 1;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
}
.close-icon {
  cursor: pointer;
}
.arrow{
  width: 10%;
  margin: 50px auto 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.arrow > img{
  width: 10px;
  cursor: pointer;
}

.link {
  color: #231815;
  font-size: 1vw;
  letter-spacing: 0.2em;
}
@media (min-width: 640px) {
  .brand-modal{
    padding: 35px 32px 25px;
  }
  .close-icon {
    width: 20px;
  }
  .content.sp{
    display:none;
  }
  .content.pc{
    position: relative;
    display: flex;
    justify-content: center;
    flex-flow: column;
    padding-left: 50px;
  }
  .sp > .link {
    display: none;
  }
  .link {
    position: absolute;
    top: 50%;
    left: 0px;
    transform: translateY(-50%);
    writing-mode: vertical-lr;
  }
  .row{
  display: flex;
  justify-content: space-between;
  }

  .row > .image{
    flex: 1;
  }
  .row > .text{
    width: 53%;
    font-size: 1vw;
    line-height: 2;
  }

  .lower {
    margin-top: 7vh;
  }
  .brand-image {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .brand-image img{
    width: 80%;
    max-width: 400px;
  }
  .description {
    display: flex;
    justify-content: flex-start;
  }
  .brand-logo{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .brand-logo img{
    width: 40%;
    max-width: 164px;
  }
  .profile {
    font-size: 11px;
  }
  .profile .designer {
    font-size: 1.2vw;
  }
  .profile .born {
    font-size: 11px;
    margin-bottom: 10px;
  }
}

@media (max-width: 639px) {
  .content.pc{
    display:none;
  }
  .content.sp{
    padding: 55px 7px 20px;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .content.sp::-webkit-scrollbar {
    display: none;
  }
  .brand-modal{
    padding: 35px 32px 25px;
  }
  .close-icon {
    width: 20px;
  }
  .arrow {
    width: 25%;
    margin-top: 30px;
  }
  .brand-image {
    margin-bottom: 55px;
  }
  .brand-logo {
    width: 40%;
    margin: 0px auto 55px;
  }
  .description {
    font-size: 12px;
    line-height: 2;
    margin-bottom: 40px;
  }
  .profile {
    font-size: 10px;
    line-height: 2;
    margin-bottom: 55px;
  }

  .profile .designer{
    font-size: 12px;
  }
  .profile .born{
    margin-bottom: 10px;
  }

  .pc > .link {
    display: none;
  }

  .link {
    display: block;
    text-align: center;
    margin-bottom: 25px;
    font-size: 10px;
  }
}
/* 小さい端末 */
@media (max-width: 375px) {
  .brand-modal{
    padding: 25px 20px 20px;
  }
  .header {
    padding-bottom: 20px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/modules/BrandModal.vue